export class IBusinessOperationQualifier {
    parentTermListName: string;
    parentTermValueCode: string;
    parentTermValueName: string;
    childTermListName: string;
    childTermValueCode: string;
    childTermValueName: string;
}
